import { Button } from '@/components/common/button'
import { Note } from '@/components/common/note'
import { LoadingIcon } from '@/components/icons/loading'

interface TxContextErrorProps {
  variant: 'initial' | 'refresh'
  isFetching: boolean
  onRetry: () => void
}

export const TxContextError = ({ variant, isFetching, onRetry }: TxContextErrorProps) => (
  <Note color="red" role="status" aria-live="polite">
    <div className="text-sm">
      <p className="inline">
        {variant === 'refresh' ? 'Unable to refresh transaction details.' : 'Unable to load transaction details.'}
      </p>{' '}
      <Button
        type="button"
        variant="default"
        size="default"
        className="gap-1 text-sm underline"
        disabled={isFetching}
        onClick={onRetry}
      >
        {isFetching ? 'Retrying…' : 'Try again'}
        {isFetching && <LoadingIcon size={16} className="animate-spin" />}
      </Button>
    </div>
  </Note>
)
